export default "__VITE_ASSET__9eb5c688__"